// extracted by mini-css-extract-plugin
module.exports = {"fullScreenWidth":"base-sort-table_fullScreenWidth__1WXky"};